export default "__VITE_ASSET__e670080c__"